import { render } from "./UsageViewThreatDetails.vue?vue&type=template&id=52c00a1a&scoped=true"
import script from "./UsageViewThreatDetails.vue?vue&type=script&lang=js"
export * from "./UsageViewThreatDetails.vue?vue&type=script&lang=js"

import "./UsageViewThreatDetails.vue?vue&type=style&index=0&id=52c00a1a&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c00a1a"]])

export default __exports__